import Modal from '@amzn/meridian/modal';
import Theme from '@amzn/meridian/theme';
import {
  MICRO_FRONTENDS_CONFIG,
  MicroFrontend,
  MicroFrontends,
} from '@amzn/rangoli-seller-desktop-utils/src/index';
import React from 'react';

const modalToken = {
  modalBorderRadius: '0.75rem',
};

interface BusinessDetailsModalProps {
  setShowBusinessDetailsModal: (value: boolean) => void;
}

const BusinessDetailsModal = ({
  setShowBusinessDetailsModal,
}: BusinessDetailsModalProps): React.JSX.Element => {
  return (
    <Theme tokens={modalToken}>
      <Modal bodySpacingInset="500 500 500 500" open={true} width="39rem" scrollContainer="modal">
        <MicroFrontend
          remoteEntryPointUrl={MICRO_FRONTENDS_CONFIG[MicroFrontends.BUSINESS_DETAILS].remoteUrl}
          scope={MICRO_FRONTENDS_CONFIG[MicroFrontends.BUSINESS_DETAILS].scope}
          module={MICRO_FRONTENDS_CONFIG[MicroFrontends.BUSINESS_DETAILS].module}
          handleCloseModal={() => setShowBusinessDetailsModal(false)}
        />
      </Modal>
    </Theme>
  );
};

export default BusinessDetailsModal;
